import { useDroppable } from '@dnd-kit/core';
import type { ContactListItem, StatutPipeline } from '@cockpit/shared';
import { KanbanCard } from './KanbanCard';
import { formatEuro, LABEL_STATUT_PIPELINE } from '../../../lib/format';

const COLOR_BY_STATUT: Record<StatutPipeline, string> = {
  Prospect: 'border-slate-600',
  Contacte: 'border-blue-600',
  Devis_envoye: 'border-amber-600',
  Negociation: 'border-purple-600',
  Gagne: 'border-floryon-green',
  Perdu: 'border-red-700',
  En_pause: 'border-slate-500',
};

interface Props {
  statut: StatutPipeline;
  items: ContactListItem[];
  totalValeurEstimeeCentimes: number;
}

export function KanbanColumn({ statut, items, totalValeurEstimeeCentimes }: Props): JSX.Element {
  const { isOver, setNodeRef } = useDroppable({ id: `col-${statut}`, data: { statut } });

  return (
    <div
      ref={setNodeRef}
      className={`bg-slate-900/40 border-t-2 ${COLOR_BY_STATUT[statut]} rounded-md p-3 flex flex-col min-w-[260px] w-[260px] shrink-0 ${
        isOver ? 'bg-slate-900/80' : ''
      }`}
    >
      <div className="mb-3">
        <div className="text-sm font-semibold text-slate-200">{LABEL_STATUT_PIPELINE[statut]}</div>
        <div className="text-[11px] text-slate-500 flex items-center justify-between">
          <span>
            {items.length} contact{items.length > 1 ? 's' : ''}
          </span>
          {totalValeurEstimeeCentimes > 0 && (
            <span className="text-floryon-green font-medium">
              {formatEuro(totalValeurEstimeeCentimes)}
            </span>
          )}
        </div>
      </div>
      <div className="flex-1 min-h-[100px] overflow-y-auto">
        {items.map((c) => (
          <KanbanCard key={c.id} contact={c} />
        ))}
        {items.length === 0 && (
          <div className="text-xs text-slate-600 italic text-center py-6">Glisser ici</div>
        )}
      </div>
    </div>
  );
}
